import { createFileRoute } from '@tanstack/react-router';
import { DirectFeedbackFeed } from '../../../features/direct-feedback';
import { interactionFeedSearchSchema } from '../../../features/interactions';

function RouteComponent() {
  return <DirectFeedbackFeed />;
}

export const Route = createFileRoute('/_auth/_feed/feedback')({
  validateSearch: interactionFeedSearchSchema,
  component: RouteComponent,
});
